__turbopack_context__.v({
  "card": "AddToCartSliderContent-module-scss-module__eDuAAG__card",
  "container": "AddToCartSliderContent-module-scss-module__eDuAAG__container",
  "details": "AddToCartSliderContent-module-scss-module__eDuAAG__details",
  "divider": "AddToCartSliderContent-module-scss-module__eDuAAG__divider",
  "image": "AddToCartSliderContent-module-scss-module__eDuAAG__image",
  "imagePlaceholder": "AddToCartSliderContent-module-scss-module__eDuAAG__imagePlaceholder",
  "imageWrap": "AddToCartSliderContent-module-scss-module__eDuAAG__imageWrap",
  "name": "AddToCartSliderContent-module-scss-module__eDuAAG__name",
  "pricing": "AddToCartSliderContent-module-scss-module__eDuAAG__pricing",
  "qty": "AddToCartSliderContent-module-scss-module__eDuAAG__qty",
});
